import React from "react";
import useReview from "../hooks/useReview";
import UserReview from "../userReview/userReview";
import './Review.css'

const Review = () => {
  const [reviews] = useReview();
  return (
    <div className="review-container">
      {reviews.map((review) => (
        <UserReview review={review}></UserReview> 
      ))}
    </div>
  );
};

export default Review;
